import { render } from "./EmojiPicker.vue?vue&type=template&id=31b7f1bb&scoped=true"
import script from "./EmojiPicker.vue?vue&type=script&lang=js"
export * from "./EmojiPicker.vue?vue&type=script&lang=js"

import "./EmojiPicker.vue?vue&type=style&index=0&id=31b7f1bb&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31b7f1bb"],['__file',"webpack-assets/vue/templates/chat/parts/EmojiPicker.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "31b7f1bb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('31b7f1bb', __exports__)) {
    api.reload('31b7f1bb', __exports__)
  }
  
  module.hot.accept("./EmojiPicker.vue?vue&type=template&id=31b7f1bb&scoped=true", () => {
    api.rerender('31b7f1bb', render)
  })

}


export default __exports__